export default __webpack_public_path__ + "img/header-4002ad09.png";